import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";
import { encode as base64_encode, decode as base64_decode } from "base-64";

class SensorStore {
  sensors = [];
  assetList = [];
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      sensors:   observable,
      assetList: observable,
      total:     observable,
      loading:   observable,
      loadData:     action,
      addData:      action,
      updateSensor: action,
      getSensorData: action,
      deleteRecord: action,
      exportExcel:  action,
      getAssetList: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, assetName, sensorId, sensorName }) {
    this.loading = true;

    const params = {
      offset,
      limit,
      companyId,
      assetName,
      sensorId,
      sensorName,
    };
    console.log("params",params)

    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/vehicle/getSensorData", { params });

    if (response?.data?.data === null) {
      this.sensors = [];
    } else {
      this.sensors = response?.data?.sensordata ?? [];
      console.log("This is the in sensor data",this.sensors);
    }

    this.total = parseInt(response?.data?.TotalCount) || 0;
    this.loading = false;
  }

  async getSensorData(sensorId) {
    const params = { sensorId, limit: 1, offset: 0 };

    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/sensor/get-sensors", { params });

    return response.data?.sensorData?.[0];
  }

  async addData(companyId,GridDetails) {
    const postData= {
      companyId:companyId,
      GridDetails:GridDetails
    }
    console.log("this is the post data",)
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/updateSensor", postData);

    return response;
  }

  async updateSensor(data) {
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/updateSensor", data);

    return response;
  }

  async deleteRecord({ sensorId, vehicleId }) {
    const response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/vehicle/deleteSensorDetails/${sensorId}/${vehicleId}`);

    return response;
  }

  async getAssetList({ companyId }) {

    const postData ={ companyId }

    // const base64Input = await base64_encode(JSON.stringify(postData));
    //     var response = await postApi
    //       .getClient()
    //       .post("index.php?c=vehicle&a=getVehicles2", "postData=" + base64Input);
    // const response = await postApi
    //   .getClient("")
    //   .get(config.NodeUrl + "/sensor/get-assets", {
    //     params: { companyId },
    
    //   });
     const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
          .getClient()
          .post("index.php?c=vehicle&a=getVehicles2", "postData=" + base64Input);
    
        this.assetList = response?.data?.data;

    // this.assetList = response?.data?.assetData ?? [];
    return this.assetList;
  }

  async exportExcel(postData) {
    try {
      const response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/sensor/exportSensorExcel", postData, {
          responseType: "blob",
        });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Sensor Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default SensorStore;